/* SLIDE 37 */
/* SLIDE 38 */

import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonBot from "shared/components/ButtonBot";
import SubHeader from "shared/components/SubHeader";
import AppInput from "shared/components/AppInput";
import AppSelect from "../../../shared/components/AppSelect";

const UserAddressManagerEdit = () => {
  const navigation = useNavigate();
  const location = useLocation();

  const [type, setType] = useState("사용자 구분");
  const [addressValue, setAddressValue] = useState("");
  const [showInputaddress, setShowInputaddress] = useState(false);

  const onNavi = (path) => {
    navigation(path);
  };

  const handleSelectChange = (e) => {
    const option = e;
    setType(e);
    if (option == "근무자") {
      setShowInputaddress(true);
    } else {
      setShowInputaddress(false);
    }
  };

  const changeInputValue = () => {
    if (addressValue == "") {
      setAddressValue("새마을시장주차장 (01-002)");
    } else {
      setAddressValue("");
    }

  }

  return (
    <div className="parking-status-container ">
      <SubHeader>
        <div className={`sub-header-text w-full`}>
          <span className="htBold" style={{ fontSize: "16px" }}>근무지 설정</span>
        </div>
      </SubHeader>
      <div className="htContent pb-80 mn-content-edit-user-address">
        <AppInput className="htBold" label="사용자명" placeholder="민길동" />

        <AppInput
          className="htBold"
          label="사용자ID"
          placeholder="사용자ID"
        />

        <AppInput
          className="htBold"
          label="비밀번호"
          placeholder="비밀번호 초기화"
        />

        <AppSelect
          label={"사용자 구분"}
          options={[
            { value: "사용자 구분", label: "사용자 구분" },
            { value: "근무자", label: "근무자" },
          ]}
          onChange={(e) => handleSelectChange(e.target.value)}
          value={type}
        ></AppSelect>


        {showInputaddress && (
          <div className="form-group">
            <label>근무지 설정</label>
            <div className="address-input">
              <input type="text" defaultValue={addressValue} placeholder="근무지 설정" />
              <button className="search-button-input" onClick={changeInputValue}>찾아보기</button>
            </div>
          </div>
        )}

        <AppInput
          className="htBold"
          label="비밀번호"
          placeholder="개인정보 이용 동의 휴 수집 몇 수정가능"
        />

        <div className="form-group">
          <div className="notice-content" style={{ borderRadius: "6px" }}>
            <div className="notice-text-content mn-text-edit-user-address">
              <span className="htBold">*사용자ID</span>
              <p style={{ paddingTop: "5px" }}>- 영문 대소문자, 특수문자(-,_) 사용가능 </p>
              <p>- 공백 금지 </p>
              <p style={{ paddingBottom: "10px" }}>- 이미 사용중인 ID 생성 불가</p>
              <span className="htBold">*비밀번호</span>
              <p style={{ paddingTop: "5px" }}>- 영문, 숫자를 혼합하여 6~10자 이내</p>
            </div>
          </div>
        </div>

        <ButtonBot
          textYes={"저장하기"}
          handleYes={() => onNavi("/user_manager_edit")}
          textNo={"취소하기"}
          handleNo={() => navigation("/menu_manager", { replace: true })}
        />
      </div>
    </div>
  );
};

export default UserAddressManagerEdit;
